import { defineMessages } from 'react-intl';

export default defineMessages({
  pullRequestsPageAuthorFilterPlaceholder: {
    id: 'frontbucket.workspace.sections.pullrequests.author.placeholder',
    description: 'Placeholder for workspace pull request page author filter',
    defaultMessage: 'Author',
  },
  pullRequestsPageAuthorFilterAddMoreMessage: {
    id: 'frontbucket.workspace.sections.pullrequests.author.addmoremessage',
    description:
      'Text shown for adding more authors on workspace pull request page author filter',
    defaultMessage: 'add more authors...',
  },
});
